module.exports = __webpack_public_path__ + "img/ogn.595305e0.gif";